import styled from 'styled-components';
import { ReactComponent as IconClose } from 'shared/assets/images/icons/iconClose.svg';

export const DefaultIconClose = styled(IconClose)`
  width: 18px;
  height: 18px;
  color: var(--color-text-dark, #042a2a);
  cursor: pointer;
`;
